export const handleFalse = (cb) => () => cb(false)
export const handleTrue = (cb) => () => cb(true)